// ENUMS #############################################################
export enum BusinessPremisesEntityTooltipIdentifierEnum {
	ADDRESS = 'address',
	CREATED_DATE = 'createdDate',
	DESCRIPTION = 'description',
	IDENTIFIER = 'businessPremisesIdentifier',
	LAST_MODIFIED_DATE = 'lastModifiedDate',
	NAME = 'name',
	STATUS = 'status'
}

// CONSTANTS #########################################################


// TYPES #############################################################


// INTERFACES ########################################################
export interface IBusinessPremisesEntityTooltipItem {
	identifier: BusinessPremisesEntityTooltipIdentifierEnum;
}


// ENTITIES ##########################################################

